/** Loading skeleton shown while a route chunk loads. */
export function PageSkeleton() {
  return (
    <div className="pt-28 sm:pt-32 pb-20" role="status" aria-label="Loading page">
      <span className="sr-only">Loading…</span>
      <div className="container-wide">
        <div className="max-w-3xl mx-auto text-center space-y-4">
          <div className="skeleton h-5 w-32 mx-auto" />
          <div className="skeleton h-10 sm:h-12 w-full" />
          <div className="skeleton h-10 sm:h-12 w-4/5 mx-auto" />
          <div className="skeleton h-4 w-3/4 mx-auto" />
          <div className="skeleton h-4 w-2/3 mx-auto" />
        </div>
        <div className="grid sm:grid-cols-3 gap-4 mt-12">
          {[0, 1, 2].map((i) => (
            <div key={i} className="rounded-xl border border-border/60 p-5 space-y-3">
              <div className="skeleton h-11 w-11 rounded-lg" />
              <div className="skeleton h-5 w-2/3" />
              <div className="skeleton h-4 w-full" />
              <div className="skeleton h-4 w-5/6" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
